<!-- eslint-disable vue/no-v-html -->
<template>
  <div>
    <div>
      <h1 class="text-black mb-25 text-center h5">
        {{ schedulerModalHeader }}
      </h1>
      <img :src="schedulerLogo" alt="ComplexCare" />
      <div class="px-80 mt-10 text-center">
        <HMButton rounded="full" @click="goToLink(schedulerUrl)">
          {{ schedulerCardButtonMessage }}
        </HMButton>
      </div>
      <Body class="text-center mt-30">
        <span class="block">{{ schedulerUrlRedirectMessage }}</span>
        <div class="or_seperator mt-20 text-grey-500">
          <h5 class="flex items-center font-semibold">
            <span class="px-8"> {{ $t('common.or').toUpperCase() }}</span>
          </h5>
        </div>
        <h1 class="text-black mt-20 text-center h5">
          {{ $t('health_actions.scheduler.modal_call_header') }}
        </h1>
      </Body>
      <div class="px-80 mt-20 mb-20 text-center">
        <a class="text-blue-500" :href="`tel:${schedulerPhoneNumber}`">
          {{ schedulerPhoneNumberMessage }}
        </a>
      </div>
      <div class="px-10 mt-10 text-center">
        {{ schedulerLearnMoreDescription }}
      </div>
      <div class="px-10 text-center">
        <a class="text-blue-500 underline" :href="schedulerLearnMoreUrl">
          {{ $t('health_actions.scheduler.learn_more') }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import healthActionMixin from '@platform-shared/mixins/health-actions/healthActionMixin.js'

export default {
  mixins: [healthActionMixin],
  methods: {
    goToLink(schedulerUrl) {
      window.open(schedulerUrl, '_blank')
    },
  },
}
</script>

<style scoped>
.or_seperator h5::before,
.or_seperator h5::after {
  content: '';
  flex-grow: 1;
  height: 1px;
  background: #bbb;
}
</style>
